import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const LicensePlatesPage = lazy(() => import('../pages/services/license-plates/page'));
const VehicleRegistrationPage = lazy(() => import('../pages/services/vehicle-registration/page'));
const TitleTransferPage = lazy(() => import('../pages/services/title-transfer/page'));
const DuplicateTitlePage = lazy(() => import('../pages/services/duplicate-title/page'));
const TemporaryPermitsPage = lazy(() => import('../pages/services/temporary-permits/page'));
const NotaryServicesPage = lazy(() => import('../pages/services/notary/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const FeesPage = lazy(() => import('../pages/fees/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const FormsPage = lazy(() => import('../pages/forms/page'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/fees', element: <FeesPage /> },
  { path: '/faq', element: <FAQPage /> },
  { path: '/resources', element: <ResourcesPage /> },
  { path: '/forms', element: <FormsPage /> },
  { path: '/services/vehicle-registration', element: <VehicleRegistrationPage /> },
  { path: '/services/license-plates', element: <LicensePlatesPage /> },
  { path: '/services/title-transfer', element: <TitleTransferPage /> },
  { path: '/services/duplicate-title', element: <DuplicateTitlePage /> },
  { path: '/services/temporary-permits', element: <TemporaryPermitsPage /> },
  { path: '/services/notary', element: <NotaryServicesPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '*', element: <NotFoundPage /> },
];

export default routes;
